// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__58hIp","footer":"styles_footer__1hqB9"};